<template>
    <a :href="`/archive/${href}`" target="_blank" class="literature-item gap-4 flex flex-col jutstify-center items-center">
        <div class="h-full w-auto relative">
            <img :alt="name" class="h-full w-full" :src="`/images/catalogs/${img}`" />
            <div class="overlay w-full h-full flex justify-center items-center text-center text-white absolute top-0 left-0">
                <p>{{ name }}</p>
            </div>
        </div>
        <button class="btn btn-primary btn-pill">Download</button>
    </a>
</template>

<script>
export default {
    name: "LiteratureItem",
    props: {
        name: {
            type: String,
            required: true,
            default: 'Literature'

        },
        href: {
            type: String,
            required: true,
            default: "#",
        },
        img : {
            type: String,
            required: true,
            default: '#'
        }
    },
};
</script>
<style lang="scss" scoped>
    .literature-item {
        .overlay {
            background: rgba(0, 0, 0, 0.6);
            opacity: 0;
            transition: opacity 0.45s ease;
        }

        &:hover {
            .overlay {
                opacity: 1;
            }
        }
    }
</style>
